import { Box, InputLabel, MenuItem, Select } from '@mui/material';
import ConstFilterElements from '../const-filter-elements';
import { DateFilterProps } from './dto';
import { GenericTableDateFilterFormat } from 'inside-fifa/api/generic-tables/dto';

const DateFilter: React.FC<DateFilterProps> = (props) => {
    return (
        <ConstFilterElements
            isDateFilter
            setSelectedDataColumn={props.setSelectedDataColumn}
            selectedDataColumn={props.selectedDataColumn}
            isShowOutsideChecked={props.isShowOutsideChecked}
            dataColumns={props.dataColumns}
            setShowOutsideChecked={props.setShowOutsideChecked}
            isHideOptionAll = {false}
            isShowHideOptionAllSelector = {false}
            setHideOptionAll={props.setHideOptionAll}
            label={props.label}
            setLabel={props.setLabel}
            languages={props.languages}
        >
            <Box display="grid" sx={{ py: 1 }}>
                <InputLabel id="input-label-date-format">Date Format:</InputLabel>
                <Select
                    aria-labelledby="input-label-date-format"
                    fullWidth
                    value={props.selectedDateTypeKey}
                    onChange={(e) => props.setSelectedDateTypeKey(e.target.value as GenericTableDateFilterFormat)}
                >
                    {props.dateFormats?.map((format) => (
                        <MenuItem key={format.key} value={format.key}>
                            {format.placeholder}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        </ConstFilterElements>
    );
};

export default DateFilter;
